module.exports = __webpack_public_path__ + "static/media/NoMessageIconMidBlue.83606b8f.svg";